// extracted by mini-css-extract-plugin
export default {"form":"ExpenseForm_form__LI7PQ","submit":"ExpenseForm_submit__Z51s0"};